<template>
	<div v-if="marker">
		<div class="map-slideout__wrapper">
			<button class="map-slideout__close-button" @click="closeSlideOut">
				<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="m1 1 10 10M11 1 1 11" stroke="#14332D" stroke-width="1.6" stroke-linejoin="round" />
				</svg>
			</button>

			<div class="map-slideout__link">
				<span v-if="marker.popup_title">{{ marker.popup_title }}</span>
				<span v-else-if="marker.street_name">{{ marker.street_name }} {{ marker.street_number }}</span>
				<span v-else>{{ marker.title }}</span>

				<a
					:href="mapsUrl"
					target="blank"
					class="c-button c-button--slideout"
					v-if="marker.location_status !== 'planned' && !fullScreen"
				>
					<svg class="icon icon-arrow">
						<use xlink:href="#icon-arrow"></use>
					</svg>
					{{ labels.view_in_google_maps }}
				</a>
			</div>
			<div class="map-slideout__image" v-if="marker.image">
				<img :src="marker.image.sizes.medium_large" alt="" />

				<div class="map-slideout__label" v-if="marker.label">
					{{ marker.label }}
				</div>
			</div>
			<div
				class="map-slideout__content"
				:class="`map-slideout__content--${marker.location_status}`"
				v-if="marker.information || marker.amenities.length > 0"
			>
				<div class="map-slideout__label map-slideout__label--mobile" v-if="marker.label">
					{{ marker.label }}
				</div>

				<div
					class="map-slideout__info"
					v-if="marker.information && !fullScreen && marker.location_status == 'operational'"
					v-html="marker.information"
				></div>

				<a
					:href="marker.url"
					target="blank"
					class="c-button c-button--border c-button--slideout map-slideout__location-button"
					v-if="marker.location_status == 'operational' && !fullScreen"
				>
					<svg class="icon icon-arrow">
						<use xlink:href="#icon-arrow"></use>
					</svg>
					{{ labels.more_information }}
				</a>

				<div class="map-slideout__charging-info" v-if="showChargingInfo">
					<div class="map-slideout__charging-title">{{ labels.charging_information }}</div>
					<div class="map-slideout__charging-info-items map-slideout__charging-info-items--fixed">
						<div class="map-slideout__charging-info-item">
							<svg class="icon icon-e-trucks-only map-slideout__charging-info-item-icon"><use xlink:href="#icon-e-trucks-only"></use></svg>
							<div class="map-slideout__charging-info-item-text">
								<span class="map-slideout__charging-info-label">
									{{ labels.electric_trucks_only }}
								</span>
							</div>
						</div>
					</div>
					<div class="map-slideout__charging-info-items">
						<div class="map-slideout__charging-info-item" v-for="(info, key) in chargingInfo">
							<svg class="icon map-slideout__charging-info-item-icon" :class="`icon-${key}`">
								<use :xlink:href="`#icon-${key}`"></use>
							</svg>
							<div class="map-slideout__charging-info-item-text">
								<span v-if="key === 'charging_bays'" class="map-slideout__charging-info-label">
									Charging bays
								</span>

								<span v-if="key === 'ccs'" class="map-slideout__charging-info-label"> CCS </span>

								<span v-if="key === 'mcs'" class="map-slideout__charging-info-label"> MCS </span>
								{{ info }}
							</div>
						</div>
					</div>
				</div>

				<button
					@click="showAmenities = !showAmenities"
					:class="
						showAmenities
							? 'map-slideout__amenitybtn'
							: 'map-slideout__amenitybtn map-slideout__amenitybtn--collapsed'
					"
				>
					{{ labels.amenities }}
					<svg class="icon icon-chevron">
						<use xlink:href="#icon-chevron"></use>
					</svg>
				</button>

				<ul class="map-slideout__amenities" v-show="showAmenities">
					<!-- <li v-if="marker.amenities.includes('ccs')">
						<svg class="icon icon-ccs">
							<use xlink:href="#icon-ccs"></use>
						</svg>
						{{ labels.ccs_charging }}
					</li> -->
					<li v-if="marker.amenities.includes('mcs')">
						<svg class="icon icon-mcs">
							<use xlink:href="#icon-mcs"></use>
						</svg>
						{{ labels.mcs_charging }}
					</li>
					<li v-if="marker.amenities.includes('secure')">
						<svg class="icon icon-secure-parking">
							<use xlink:href="#icon-secure-parking"></use>
						</svg>
						{{ labels.secure_parking }}
					</li>
					<!-- <li v-if="marker.amenities.includes('drive_through')">
							<svg class="icon icon-drive-through-parking">
								<use xlink:href="#icon-drive-through-parking"></use>
							</svg>
							{{ labels.drive_through_parking }}
						</li> -->
					<li v-if="marker.amenities.includes('nose')">
						<svg class="icon icon-nose-parking">
							<use xlink:href="#icon-nose-parking"></use>
						</svg>
						{{ labels.nose_parking }}
					</li>
					<li v-if="marker.amenities.includes('restaurant')">
						<svg class="icon icon-restaurant">
							<use xlink:href="#icon-restaurant"></use>
						</svg>
						{{ labels.restaurant }}
					</li>
					<li v-if="marker.amenities.includes('vending_machine')">
						<svg class="icon icon-vending-machine">
							<use xlink:href="#icon-vending-machine"></use>
						</svg>
						{{ labels.vending_machine }}
					</li>
					<li v-if="marker.amenities.includes('toilet')">
						<svg class="icon icon-toilet">
							<use xlink:href="#icon-toilet"></use>
						</svg>
						{{ labels.toilet }}
					</li>
					<li v-if="marker.amenities.includes('shower')">
						<svg class="icon icon-shower">
							<use xlink:href="#icon-shower"></use>
						</svg>
						{{ labels.shower }}
					</li>
					<li v-if="marker.amenities.includes('lounge')">
						<svg class="icon icon-lounge">
							<use xlink:href="#icon-lounge"></use>
						</svg>
						{{ labels.lounge }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['marker', 'componentClass', 'labels', 'useRoutes', 'fullScreen'],
	data() {
		return {
			showAmenities: window.innerWidth >= 768 ? true : false,
		};
	},
	methods: {
		closeSlideOut() {
			this.$emit('close');
		},
	},
	computed: {
		chargingInfo() {
			return Object.entries(this.marker.charging_info).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {});
		},
		mapsUrl() {
			return `https://www.google.com/maps/search/?api=1&query=${this.marker.lat},${this.marker.lng}`;
		},
		showChargingInfo() {
			return Object.keys(this.chargingInfo).some((key) => this.chargingInfo[key] !== '');
		},
	},
};
</script>
